(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.headerSizeObserver = new ResizeObserver(() => this.setHeaderHeight());
      this.headerSizeObserver.observe(this.header);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.headerSizeObserver?.disconnect();
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-review-room"]) return;
  try {
    
if (!customElements.get('nx-review-room')) {
  class NaturexReviewRoom extends HTMLElement {
    connectedCallback() {
      this.addEventListener('nx:reviews-loaded', event => this.updateOverview(event.detail));
      this.addEventListener('nx:reviews-error', event => { this.querySelector('[data-nxr-count]').textContent = event.detail; });
      this.querySelectorAll('[data-nxr-write]').forEach(button => button.addEventListener('click', () => this.querySelector('[data-nx-write]').click()));
      this.querySelectorAll('[data-nx-rating-filter],[data-nx-photos-filter]').forEach(input => input.addEventListener('change', () => this.filter()));
      this.querySelectorAll('[data-nxr-stars]').forEach(button => button.addEventListener('click', () => {
        const select = this.querySelector('[data-nx-rating-filter]');
        select.value = select.value === button.dataset.nxrStars ? 'all' : button.dataset.nxrStars;
        this.filter();
      }));
      const reviews = this.querySelector('nx-product-reviews');
      if (reviews?.data) this.updateOverview(reviews.data);
    }
    filter() {
      const widget = this.querySelector('nx-product-reviews');
      widget.limit = 6;
      if (widget.data) widget.render();
      const value = this.querySelector('[data-nx-rating-filter]').value;
      this.querySelectorAll('[data-nxr-stars]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.nxrStars === value)));
    }
    updateOverview(data) {
      const nf = new Intl.NumberFormat(this.dataset.locale || 'en');
      this.querySelector('[data-nxr-average]').textContent = data.count ? data.rating.toFixed(1) : '—';
      this.querySelector('[data-nxr-count]').textContent = (data.count === 1 ? this.dataset.countOne : this.dataset.countLabel).replace('__COUNT__',nf.format(data.count));
      this.querySelector('[data-nxr-distribution]').hidden = !data.count;
      this.querySelector('[data-nxr-filters]').hidden = !data.count;
      this.querySelectorAll('[data-nxr-stars]').forEach(button => {
        const count = data.reviews.filter(review => review.rating === Number(button.dataset.nxrStars)).length;
        button.querySelector('[data-nxr-star-count]').textContent = nf.format(count);
        button.querySelector('[data-nxr-bar]').style.width = (data.count ? count / data.count * 100 : 0) + '%';
        button.setAttribute('aria-label',this.dataset.filterLabel.replace('__RATING__',button.dataset.nxrStars).replace('__COUNT__',nf.format(count)));
      });
    }
  }
  customElements.define('nx-review-room',NaturexReviewRoom);
}

  } catch(e) { console.error(e); }
})();
})();
